import { TableCell } from "@/components/ui/table.tsx"
import { numberFmt } from "@/util/numberFmt.ts"

import type { FarmBalanceAmounts } from "../types/farmBalanceTypes.ts"

export const PERIOD_COLUMNS = 5

export default function FarmBalanceCells({ amounts }: { amounts: FarmBalanceAmounts }) {
  const { volumeIn, volumeOut, net, penaltyVolume, penaltyRoyalty } = amounts

  return (
    <>
      <TableCell className="text-center">{numberFmt(volumeIn)}</TableCell>
      <TableCell className="text-center">{numberFmt(volumeOut)}</TableCell>
      <TableCell
        className={`text-center font-semibold ${net >= 0 ? "text-status-good" : "text-status-bad"}`}
      >
        {numberFmt(net)}
      </TableCell>
      <TableCell
        className={`text-center ${
          penaltyVolume == null
            ? "text-muted-foreground"
            : penaltyVolume > 0
              ? "font-semibold text-status-bad"
              : ""
        }`}
      >
        {penaltyVolume == null ? "—" : numberFmt(penaltyVolume)}
      </TableCell>
      <TableCell className={`text-center ${penaltyRoyalty == null ? "text-muted-foreground" : ""}`}>
        {penaltyRoyalty == null ? "—" : "$" + numberFmt(penaltyRoyalty, true)}
      </TableCell>
    </>
  )
}
